
import BusinessApi from './src/BusinessApi'
import BusinessPayOrderApi from './src/BusinessPayOrderApi'
import BusinessOutPaymentApi from './src/BusinessOutPaymentApi'
import BusinessTypeApi from './src/BusinessTypeApi'
import ChildBusinessApi from './src/ChildBusinessApi'
import ScenicApi from './src/ScenicApi'
import UserApi from './src/user-api'
import UserRoleApi from './src/user-role-api'

let apis = {
    BusinessApi,
    BusinessPayOrderApi,
    BusinessOutPaymentApi,
    BusinessTypeApi,
    ChildBusinessApi,
    ScenicApi,
    UserApi,
    UserRoleApi
};

export default apis;
